// extracted by mini-css-extract-plugin
export default {"root":"CapacityOverrideDialog_root__OJcnz","textArea":"CapacityOverrideDialog_textArea__HBrN5"};